"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_NUMBER_OF_TILES = exports.FIND_YOUR_PRODUCT_ROOT_MOBILE = exports.FIND_YOUR_PRODUCT_ROOT_DESKTOP = exports.FIND_YOUR_PRODUCT_MOBILE_SKELETON = exports.FIND_YOUR_PRODUCT_DESKTOP_SKELETON = void 0;
const FIND_YOUR_PRODUCT_ROOT_MOBILE = exports.FIND_YOUR_PRODUCT_ROOT_MOBILE = 'inspiration-root-mobile';
const FIND_YOUR_PRODUCT_ROOT_DESKTOP = exports.FIND_YOUR_PRODUCT_ROOT_DESKTOP = 'inspiration-root-desktop';
const FIND_YOUR_PRODUCT_DESKTOP_SKELETON = exports.FIND_YOUR_PRODUCT_DESKTOP_SKELETON = 'inspiration-desktop-skeleton';
const FIND_YOUR_PRODUCT_MOBILE_SKELETON = exports.FIND_YOUR_PRODUCT_MOBILE_SKELETON = 'inspiration-mobile-skeleton';
const MAX_NUMBER_OF_TILES = exports.MAX_NUMBER_OF_TILES = 10;
